import React from 'react';
interface PhoneFrameProps {
  children: React.ReactNode;
}
export function PhoneFrame({
  children
}: PhoneFrameProps) {
  return <div className="relative mx-auto w-[390px] max-w-full shrink-0 rounded-[46px] border-[10px] border-vin-ink bg-vin-ink shadow-phone" data-id="element-224" data-mp="1svme0z8jwy0y">
      <div className="relative h-[780px] overflow-hidden rounded-[36px] bg-vin-mist" data-id="element-225" data-mp="22kw6ig7b4ipl">
        <div className="pointer-events-none absolute left-1/2 top-2 z-40 h-6 w-28 -translate-x-1/2 rounded-full bg-vin-ink" data-id="element-226" data-mp="22mz3jk6vnc3t" />
        {children}
      </div>
    </div>;
}